import { Button, Typography, IconButton, Badge } from '@mui/material'
import React, { useState } from 'react'
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { Hint } from '../../store/service/types';

type Props = {
    availableHints: number;
    task_index: number;
    onClick: (task_index: number) => void;
};

export const HintButton = ({availableHints, task_index, onClick}: Props) => {
        return (
            <IconButton 
                disabled={(availableHints <= 0) ? true : false}
                color={'warning'}
                size='small'
                onClick={()=>{onClick(task_index)}}>
                    <Badge badgeContent={availableHints} color={'error'}>
                        <LightbulbIcon/>
                    </Badge>
            </IconButton>
            )
}

export default HintButton